import {
  ClientOptions,
  FeatureFlagsClient,
  FlagBaseContext,
  Team,
} from '@getvim/feature-flags/client';
import { createFeatureFlagContext } from '@getvim/feature-flags/react';
import { isEmpty, trim } from 'lodash-es';
import { WidgetSource } from '../components/app/types';

interface OAFlagContext extends FlagBaseContext {
  insurer?: string;
  source?: WidgetSource;
  organizationId?: number;
  adapterName?: string;
  agentVersion?: string;
  agentType?: string;
}

const {
  rollout__key: rolloutKey,
  VIM_feature_flags__proxy_url: proxyUrl,
  VIM_feature_flags__unify_key: unifyKey,
} = globalThis.$vim_environment ?? {};

const ffClientOptions: ClientOptions<OAFlagContext> = {
  team: Team.OrderOptimization,
  namespace: 'vim_connect',
  rolloutKey,
  proxyUrl: proxyUrl,
  unifyKey: isEmpty(trim(unifyKey)) ? undefined : unifyKey,
  defaultContext: {},
};

const { FeatureFlagProvider, useFeatureFlag } = createFeatureFlagContext<OAFlagContext>();

// Initialize singleton at module load
const featureFlagsClient = FeatureFlagsClient.getInstance<OAFlagContext>(ffClientOptions);

export { featureFlagsClient, FeatureFlagProvider, ffClientOptions, useFeatureFlag };
export { Team } from '@getvim/feature-flags/client';
